/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, Collapse, IconButton, Button, Divider, LinearProgress } from '@material-ui/core'

import { ExpandMore, ExpandLess } from '@material-ui/icons'

import Attachment from '../../Results/components/FileViewers/JSON/components/Attachment';
import ErrorMessage from '../../Common/ErrorMessage'
import Action from '../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
  });


const styles = theme => ({

})

class AttachmentContainer extends Component {
    state = {
        open : true,
        selected_file_for_upload: null,
        upload_percentage : 0,
        upload_error : null
    }

    componentWillMount () {
        this.setState({...this.state, open : this.props.on_open})
    }

    onFileChange = event => { 
        // Update the state 
        this.setState({ selected_file_for_upload : event.target.files[0], upload_error : null, upload_percentage : 0 }); 
    }

    uploadFile = () => {
        let formData = new FormData

        formData.append("file", this.state.selected_file_for_upload, this.state.selected_file_for_upload.name)
        formData.append("ic_name", this.props.ic_name)

        Action('http_request', {
            url : "/sainapse/world_view_server/addfile",
            method : "post",
            data : formData,
            // headers: {
            //     "Content-Type": "multipart/form-data",
            // },
            onUploadProgress : (progressEvent) => {
                const { loaded, total } = progressEvent
                let percent = Math.floor(loaded * 100 / total)
                this.setState({...this.state, upload_percentage : percent})
            }
        }).then(res => {
            console.log('File Upload Complete: ', res)
            this.setState({...this.state, upload_percentage : 0, selected_file_for_upload: null, uoload_error: null}, this.props.add_attachments(res.data))
        }).catch(err => {
            this.setState({...this.state, upload_error : err})
        })
    }

    render() { 
        console.log("Rendering Attachments :", this.props.attachments)
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', backgroundColor : '#FFFFFF', borderRadius : '5px', border :'1px solid rgba(0,0,0,0.12)'}}>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', padding: '10px'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'caption' color = 'primary'>{"Attachments (" + this.props.attachments.length + ")"}</Typography>
                        <IconButton size = 'small' onClick = {() => this.setState({...this.state, open : !this.state.open})}>
                            {this.state.open ? <ExpandLess fontSize = 'inherit'/> : <ExpandMore fontSize = 'inherit'/>}
                        </IconButton>
                    </div>
                    <Collapse in = {this.state.open}>
                        <div style = {{
                            width: '100%',
                            padding: '5px',
                            marginBottom : '10px'
                        }}>
                            {this.props.attachments.map(attachment => {
                                let record = {
                                    iu_record_src_info : {
                                        iu_content_type : {
                                            sub_type : attachment.content_type
                                        },
                                        iu_record_nav_info : {
                                            location : {
                                                position : 1
                                            }
                                        }
                                    },
                                    source_link : {
                                        path : attachment.file_name
                                    }
                                }
                                if (attachment.file_wv_address) {
                                    return (
                                        <Attachment
                                            height = '50px'
                                            server_name = {attachment.file_wv_address.wv_server_name}
                                            highlight = {false}
                                            show_title = {true}
                                            show_view = {true}
                                            file_id = {attachment.file_wv_address.wv_id}
                                            file_name = {attachment.file_name}
                                            file_type = {attachment.content_type}
                                            path = {attachment.file_name}
                                            record = {record}
                                            drl_url = {this.props.drl_url}
                                        />
                                    )
                                } else {
                                    return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                                }
                            })}
                        </div>
                        {this.props.accepts_attachments && <div style = {{width : '100%', padding : '5px'}}>
                            <Typography variant = 'caption' color = 'primary'>Add Attachments</Typography>
                            <Divider style = {{marginBottom : '5px'}}/>
                            <div style = {{width : '100%'}}>
                                {this.props.additional_attachments.map(attachment => {
                                    let record = {
                                        iu_record_src_info : {
                                            iu_content_type : {
                                                sub_type : attachment.content_type
                                            },
                                            iu_record_nav_info : {
                                                location : {
                                                    position : 1
                                                }
                                            }
                                        },
                                        source_link : {
                                            path : attachment.file_name
                                        }
                                    }
                                    if (attachment.file_wv_address) {
                                        return (
                                            <Attachment
                                                height = '50px'
                                                show_title = {true}
                                                show_view = {true}
                                                server_name = {attachment.file_wv_address.wv_server_name}
                                                file_id = {attachment.file_wv_address.wv_id}
                                                file_name = {attachment.file_name}
                                                file_type = {attachment.content_type}
                                                path = {attachment.file_name}
                                                record = {record}
                                                drl_url = {this.props.drl_url}
                                            />
                                        )
                                    } else {
                                        return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                                    }
                                })}
                            </div>
                            <div>
                                <input
                                    id="contained-button-file"
                                    type="file"
                                    onChange={this.onFileChange}
                                />
                            </div>
                            {this.state.selected_file_for_upload !== null && this.state.upload_percentage === 0 &&
                            <Button
                                style = {{marginTop: '5px'}}
                                variant = 'outlined'
                                color = 'primary'
                                size = 'small'
                                onClick = {() => this.uploadFile()}
                            >Upload</Button>}
                            {this.state.upload_percentage > 0 && this.state.upload_error === null &&
                                <div style = {{width : '100%'}}>
                                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'caption'>{this.state.upload_percentage < 100 ? "Uploading..." : "Upload Complete"}</Typography>
                                        <Typography variant = 'caption' color = 'primary'>{this.state.upload_percentage + "%"}</Typography>
                                    </div>
                                    <LinearProgress variant = 'determinate' value = {this.state.upload_percentage}/>
                                </div>
                            }
                            {
                                this.state.upload_error && <ErrorMessage error_message = "Error uploading file." err = {this.state.upload_error}/>
                            }
                        </div>}
                    </Collapse>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(AttachmentContainer);